<template>
    <div id="FormDropDownList">
        <div :class="`form-drop-downList drop-down-list-align-${align}`">
            <label
                class="form-drop-down-title"
            >
                {{ fieldLabel }}
            </label>
            <div>
                <select v-model="selectedOption" class="form-drop-down-select">
                    <option disabled value="">{{ placeholder }}</option>
                    <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
                </select>
                <div class="options-management">
                    <textarea v-model="newOptions" class="form-drop-down-textarea"
                              placeholder="seçenek 1&#10;seçenek 2"></textarea>
                    <button @click="addOptions" class="form-drop-down-button">Seçenek Ekle</button>
                    <button @click="toggleOptions" class="form-drop-down-button">
                        {{ showOptions ? "Seçenekleri Gizle" : "Seçenekleri Göster" }}
                    </button>
                    <div v-if="showOptions" class="remove-options">
                        <div v-for="option in options" :key="option" class="option-item">
                            {{ option }}
                            <button @click="removeOption(option)" class="remove-button">
                                <md-icon style="color: white">delete</md-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <input type="text" class="form-drop-down-sublabel" :value="altLabel">
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "DropDownList",
    props: {
        fieldLabel: String,
        placeholder: String,
        align: String,
        altLabel: String,
        isRequired: Boolean,
        item: Object,
    },
    data() {
        return {
            selectedOption: "",
            options: [],
            newOptions: "",
            showOptions: false,
        };
    },
    watch: {
        item: {
            handler(newItem) {
                if (newItem && newItem.dropDownList && newItem.dropDownList.items) {
                    this.options = newItem.dropDownList.items;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),

        addOptions() {
            const newOptionsArray = this.newOptions.split("\n").map(option => option.trim()).filter(option => option);
            this.options = [...new Set([...this.options, ...newOptionsArray])];
            this.newOptions = "";
            this.updateField();
        },

        removeOption(optionToRemove) {
            this.options = this.options.filter(option => option !== optionToRemove);
            this.updateField();
        },

        updateField() {
            const updateFields = {
                dropDownList: {
                    fieldLabel: this.fieldLabel,
                    align: this.align,
                    altLabel: this.altLabel,
                    isRequired: this.isRequired,
                    items: this.options,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },

        toggleOptions() {
            this.showOptions = !this.showOptions;
        },
    },
    created() {
        if (this.item && this.item.dropDownList && this.item.dropDownList.items) {
            this.options = this.item.dropDownList.items;
        }
    },
};
</script>

<style lang="scss" scoped>
#FormDropDownList {
    .form-drop-downList {
        margin-bottom: 20px;
        position: relative;

        .form-drop-down-title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 0;
            width: 100%;
            background: transparent;
        }

        .form-drop-down-select {
            width: 100%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            margin-bottom: 10px;
            appearance: none;
            background-image: url("data:image/svg+xml,...");
            background-repeat: no-repeat;
            background-position: right 10px center;
        }

        .form-drop-down-textarea {
            width: 100%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            min-height: 80px;
            margin-bottom: 10px;
            resize: vertical;
        }

        .form-drop-down-button {
            display: inline-block;
            padding: 10px 16px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 14px;
            cursor: pointer;
            margin-bottom: 10px;
            transition: background-color 0.3s ease;

            &:hover {
                background-color: darken(#007bff, 10%);
            }
        }

        .form-drop-down-sublabel {
            font-size: 12px;
            color: #666;
            border: none;
            border-bottom: 1px solid #ddd;
            padding: 4px 0;
            width: 100%;
            background: transparent;
        }
    }

    .drop-down-list-align-left,
    .drop-down-list-align-right {
        display: flex;
        align-items: center;

        .form-drop-down-title {
            width: 200px !important;
            margin-right: 10px;
            flex-shrink: 0;
        }
    }
    .drop-down-list-align-right{
        .form-drop-down-title{
            text-align: right !important;
        }
    }

    .drop-down-list-align-left .form-drop-down-title {
        text-align: left;
    }

    .drop-down-list-align-right .form-drop-down-title {
        text-align: right;
    }

    .options-management {
        margin-top: 10px;
    }

    .remove-options {
        margin-top: 10px;
    }

    .option-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        padding: 5px;
        background-color: #f0f0f0;
        border-radius: 4px;
    }

    .remove-button {
        background-color: #ff4d4d;
        color: white;
        border: none;
        padding: 2px 5px;
        border-radius: 3px;
        cursor: pointer;
        font-size: 12px;

        &:hover {
            background-color: #ff3333;
        }
    }
}
</style>
